import axios from 'axios';

axios.defaults.withCredentials = true;

// Active workspace (strategy book). Persisted in localStorage and attached to
// every request so the backend scopes watchlists / history / trading / eval.
export const WORKSPACE_STORAGE_KEY = 'activeWorkspace';

export function getActiveWorkspace() {
  return localStorage.getItem(WORKSPACE_STORAGE_KEY) || 'default';
}

export function setActiveWorkspace(slug) {
  localStorage.setItem(WORKSPACE_STORAGE_KEY, slug || 'default');
}

axios.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers['X-Workspace'] = getActiveWorkspace();
  return config;
});

export default axios;
